import React, { useRef } from 'react';
import { displayDate } from '../utils/dates';
import { ICONS } from './ui';

export default function DateNavigator({ currentDate, onPrev, onNext, hasPrev, hasNext, onDateSelect, minDate, maxDate, rightContent }) {
  const inputRef = useRef(null);

  const handleLabelClick = () => {
    if (inputRef.current) {
      inputRef.current.showPicker();
    }
  };

  const handleDateChange = (e) => {
    const val = e.target.value;
    if (val && onDateSelect) {
      onDateSelect(val);
    }
  };

  return (
    <div className="date-nav">
      <div className="date-nav-controls">
        <button onClick={onPrev} disabled={!hasPrev} aria-label="Previous day">
          {ICONS.prev}
        </button>
        <div className="date-nav-label date-nav-label-tappable" onClick={handleLabelClick}>
          {displayDate(currentDate, { weekday: true })}
          <input
            ref={inputRef}
            type="date"
            className="date-nav-hidden-input"
            value={currentDate || ''}
            min={minDate}
            max={maxDate}
            onChange={handleDateChange}
            tabIndex={-1}
          />
        </div>
        <button onClick={onNext} disabled={!hasNext} aria-label="Next day">
          {ICONS.next}
        </button>
      </div>
      {rightContent}
    </div>
  );
}
